import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { EstadosTablaComunConstant } from 'constants/index'

const EstadoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='select-estado' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='estado'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-estado'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {EstadosTablaComunConstant.__array.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoFormGroup)
